import { adminRoutes } from '@bettermode/domain/routes/web/admin'
import { T, useI18n } from '@tribeplatform/react-components/i18n'
import { useRouter } from '@tribeplatform/react-sdk'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'
import { NavVertical } from '@tribeplatform/react-ui-kit/Sidebar'

import { useSlate } from '../../hooks/slate.hook.js'
import { useMobileMenu } from '../Navbar/providers/MobileMenuProvider.js'

import { CollectionMenuSpaces } from './CollectionMenuSpaces.js'
import {
  CollectionMenuEntry,
  getCollectionMenuEntrySpaces,
  isNoCollectionEntry,
} from './types.js'

export const CollectionMenuHeading = ({
  collections,
  canCreateSpace,
  ...rest
}: {
  collections: CollectionMenuEntry[]
  canCreateSpace: boolean
}) => {
  const { Link } = useRouter()
  const { close } = useMobileMenu()
  const { mode } = useSlate()
  const isPreviewMode = mode !== 'live'
  const { catalogLocale } = useI18n()

  return (
    <NavVertical {...rest}>
      <div className="space-y-2">
        {collections.map(collection => {
          const spaces = getCollectionMenuEntrySpaces(collection, catalogLocale)

          if (isNoCollectionEntry(collection)) {
            return (
              <NavVertical.Group key={collection.id}>
                <NavVertical.Group className="pb-3">
                  <CollectionMenuSpaces spaces={spaces} />
                </NavVertical.Group>
              </NavVertical.Group>
            )
          }

          const hasSpaces = collection?.spaces?.totalCount

          if (!hasSpaces && !canCreateSpace) {
            return null
          }
          return (
            <NavVertical.Group key={collection.id}>
              <NavVertical.GroupHeader>
                {collection.name}
              </NavVertical.GroupHeader>
              <NavVertical.Group className="pb-3">
                <CollectionMenuSpaces spaces={spaces} />
                {!hasSpaces ? (
                  <NavVertical.Item
                    as={Link}
                    href={adminRoutes.design.createSpaceInCollection(
                      collection.id,
                    )}
                    onClick={e => {
                      if (isPreviewMode) {
                        e.preventDefault()
                        return
                      }

                      close()
                    }}
                  >
                    <span className="w-6 h-6 -ms-1 me-3 flex justify-center items-center">
                      <SvgIcon className="w-5 h-5" name="package-plus" />
                    </span>
                    <span className="truncate">
                      <T id="Generics.AddSpace" defaultMessage="Add {SPACE}" />
                    </span>
                  </NavVertical.Item>
                ) : null}
              </NavVertical.Group>
            </NavVertical.Group>
          )
        })}
      </div>
    </NavVertical>
  )
}
